import { render, staticRenderFns } from "./IndirectRequiredCard.vue?vue&type=template&id=fda75cc2"
import script from "./IndirectRequiredCard.vue?vue&type=script&lang=js"
export * from "./IndirectRequiredCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports